type Cookie = {
	name: string;
	value: string;
	maxAge: number;
};

export function setCookie(cookie: Cookie | Cookie[]) {
	if (Array.isArray(cookie)) {
		cookie.forEach(({ name, value, maxAge }) => {
			document.cookie = `${name}=${value}; Max-Age=${maxAge}; SameSite=Lax; Path=/;`;
		});
	} else {
		const { name, value, maxAge } = cookie;
		document.cookie = `${name}=${value}; Max-Age=${maxAge}; SameSite=Lax; Path=/;`;
	}
}

export function getCookie(cname: string) {
	const name = cname + '=';
	const decodedCookie = decodeURIComponent(document.cookie);
	const ca = decodedCookie.split(';');

	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}

	return '';
}
